import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Home, HelpCircle, DollarSign, User, Calendar, Award, Clipboard, Tablet, BarChart2, Activity, ShoppingBag, Headphones } from "react-feather";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { ReactComponent as OffersIcon    } from '~/assets/images/footer/offers.svg';
import { ReactComponent as RewardsIcon   } from '~/assets/images/footer/rewards.svg';
import { ReactComponent as TournamentIcon } from '~/assets/images/footer/tournament.svg';
import { ReactComponent as ReferralsIcon } from '~/assets/images/footer/referrals.svg';
import { ReactComponent as ExpandButton  } from '~/assets/images/footer/expand.svg';


const Footer = ()=> {

  let expandButtonRef     = useRef();
  const [isOpen, setOpen] = useState(false);

  const items = {
    left: [
      {name:'Offers' , Icon: OffersIcon  , path: '/offers'}  ,
      {name:'Rewards', Icon: RewardsIcon , path: '/rewards'} ,
    ],

    middle: [
      [
        {name : 'Home'     , Icon : Home        , path : '/'}          ,
        {name : 'Offers'   , Icon : OffersIcon  , path : '/offers'}    ,
        {name : 'Surveys'  , Icon : HelpCircle  , path : '/surveys'}   ,
//      {name : 'Cashback' , Icon : ShoppingBag , path : '/cashbacks'} ,
          {name : 'Rewards'  , Icon: RewardsIcon  , path: '/rewards'}    ,
      ], [
 //     {name : 'Jackpot' , Icon : Activity     , path : '/jackpot' } ,
          {name :'Referrals'  , Icon: ReferralsIcon , path: '/referrals'} ,
        {name : 'CheckIn'   , Icon : Calendar     , path : '/check-in'} ,
        {name : 'Tasks'     , Icon : Clipboard    , path : '/tasks'}    ,
        {name : 'Games'     , Icon : Tablet       , path : '/games'}    ,
      ], [
  //    {name : 'Lottery'   , Icon : Award         , path : '/lottery'}   ,
  //    {name : 'Contests'  , Icon : BarChart2     , path : '/contests'}  ,
          {name : 'Support'  , Icon : Headphones     , path : '/support'}   ,
          {name : 'Tournament', Icon: TournamentIcon , path: '/tournament'} ,
        {name : 'Wallet'    , Icon : DollarSign    , path : '/wallet' }   ,
        {name : 'Profile'   , Icon : User          , path : '/profile'}
      ],
    ],

    right: [
      {name:'Tournament', Icon: TournamentIcon , path: '/tournament'}  ,
      {name:'Referrals', Icon: ReferralsIcon , path: '/referrals'},
    ]
  };

  useEffect(()=> {
    let closeMenu = (e)=> {
      if(expandButtonRef.current?.contains(e.target)) return;
      setOpen(false);
    }
    document.addEventListener('click', closeMenu);
    return ()=> document.removeEventListener('click', closeMenu);
  }, []);


  return (
    <Fragment>
      <footer className="footer footer-fix">
        <div className="left">
          {items.left.map(({name, Icon, path}, index)=>
            <Link to={path} className={classNames({item: true, active: window.location.pathname == path })} key={index}>
              <Icon /> <p className="mb-0">{name}</p>
            </Link>
          )}

        </div>
        <div className="middle" ref={expandButtonRef}>
          <button className={classNames({"center-button": true, open: isOpen })} onClick={()=> setOpen(!isOpen)} >
            <ExpandButton />
          </button>

          <div className={classNames({"big-menu": true, open: isOpen })}>
            {items.middle.map((row, index)=>
              <div className="sub-menu d-flex m-b-10" key={index} onClick={()=> setOpen(false)}>
                {row.map(({name, Icon, path}, index)=>
                  <Link to={path} className={classNames({item: true, active: window.location.pathname == path })} key={index}>
                    <Icon /> <p className="mb-0">{name}</p>
                  </Link>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="right">
          {items.right.map(({name, Icon, path}, index)=>
            <Link to={path} className={classNames({item: true, active: window.location.pathname == path })} key={index}>
              <Icon /> <p className="mb-0">{name}</p>
            </Link>
          )}
        </div>

      </footer>
    </Fragment>
  );
}

export default Footer;
